export default class KeyHandler {
	keyBindings = {};
	#previousKeyBindings = {};

	constructor() {
		window.addEventListener("keydown", (event) => this.#processKey(event));
	}

	watchKey(key, method, component) {
		this.keyBindings[key] = this.keyBindings[key] ?? [];
		if (this.#componentIsWatchingKey(component, key)) {
			this.keyBindings[key].pop();
		}
		this.keyBindings[key].push(method);
		component.watchedKeyHandlers[key] = this.keyBindings[key].length - 1;
	}

	unwatchKey(key, component) {
		if (!this.#componentIsWatchingKey(component, key)) {
			return;
		}
		let watchIndex = component.watchedKeyHandlers[key];
		this.keyBindings[key] = this.keyBindings[key].slice(0, watchIndex);
		delete (component.watchedKeyHandlers[key]);
	}

	unwatchKeys(keys = null, component) {
		keys = keys ?? Object.keys(component.watchedKeyHandlers);
		keys.forEach(key => this.unwatchKey(key, component));
	}

	#componentIsWatchingKey(component, key) {
		return component.watchedKeyHandlers.hasOwnProperty(key);
	}

	#processKey(event) {
		let handler = this.keyBindings[event.key]?.at(-1);
		if (!handler) {
			return;
		}
		event.preventDefault();
		event.stopPropagation();
		handler();
	}
}
